import "./fotos.css"
function Fotos(){
return(


<div className="fotosLaurinda">
    
            
                <img src="images/laura1.jpg" alt="imagem vô e vó" />
            
                <img src="images/FotoEstiloAntigos.jpg" alt="imagem antiga" />
           
            
                <img src="images/Romantico.jpg" alt="imagem beijo" />

           

        
       
            
                <img src="images/Homens.jpg" alt="Homens da familia" />
          
                <img src="images/Familia2.jpeg" alt="foto da familia com o autor junto"/>
            
                <img src="images/family.jpeg" alt="" />
           
        
     
            
                <img src="images/festa.jpg" alt="" ></img>
            
                <img src="images/CasalLindo.jpg" alt=""></img>
           
                <img src="images/neuGaranhão.jpg" alt="" ></img>
           
      
            
                <img src="images/neu.jpg" alt="" ></img>
            
                <img src="images/netos.jpg" alt="" ></img>
          
                <img src="images/inicio.png" alt="" ></img>
            
      
            
                <img src="images/elegancia.jpg" alt="" ></img>
          
                <img src="images/Lindinhos.jpeg" alt="" ></img>
            
                <img src="images/onsbu.jpg" alt=""></img>
            
       
        
            
                <img src="images/VóFeliz.jpg" alt="" ></img>
           
                <img src="images/novinhos.jpg" alt="" />
                
        
                <img src="images/manoelbolo.jpg" alt=""></img>
           
       
           
                <img src="images/maozihas.JPG" alt="" ></img>
         
                <img src="images/rezando.JPG" alt="" ></img>
           
                <img src="images/rezando2.JPG" alt="" ></img>
    

       
           
                <img src="images/atencao.JPG" alt="" ></img>
            
                <img src="images/bodaslindos.JPG" alt="" ></img>
           
                <img src="images/casalefilha.JPG" alt="" ></img>
            
        
            
                <img src="images/filhaepais.jpg" alt="" ></img>
         
                <img src="images/irmaos.jpg" alt="" ></img>
         
                <img src="images/paiefilha.jpg" alt=""></img>
        
       
            
                <img src="images/natal1.jpeg" alt="" ></img>
            
            
                <img src="images/natal2.jpeg" alt=""></img>
            
            
                <img src="images/natal3.jpeg" alt="" ></img>
      
           
                <img src="images/casal.jpg" alt="" ></img>
            
            
                <img src="images/casal2.jpg" alt="" ></img>
          
           
                <img src="images/irmaos4.jpg" alt="" ></img>
           
       
        
                <img src="images/LucaseMarina.jpg" alt="" ></img>
    
            
                <img src="images/Guilherme.jpeg" alt="" ></img>
            

                <img src="images/O criador.jpeg" alt="" ></img>
            
      
        
                <img src="images/festaVo.jpeg" alt="" ></img>
    
        
                <img src="images/Carlos.jpeg" alt="" ></img>
        
        
                <img src="images/united.jpeg" alt="" ></img>
      
        
                <img src="images/anigofesta.jpeg" alt="" ></img>
        
                <img src="images/natalS.jpeg" alt=""></img>
    
                <img src="images/batima.jpeg" alt="" ></img>

      
        
                <img src="images/espadinha.jpeg" alt="" ></img>
    
            
                <img src="images/jogo.jpeg" alt="" ></img>
            
    
                <img src="images/voevo.jpeg" alt="" ></img>



                <img src="images/aniversario.jpeg" alt="" ></img>
    
            
                 <img src="images/avoseamiga.jpeg" alt="" ></img>


                <img src="images/familia8.jpeg" alt="" ></img>



                <img src="images/voevo6.jpeg" alt="" ></img>
    
            
                <img src="images/restaurante4.jpeg" alt="" ></img>


                <img src="images/bisoebisa.jpeg" alt="" ></img>

                

                
                <img src="images/casamento1.jpeg" alt="" ></img>
    
            
                <img src="images/casamento2.jpeg" alt="" ></img>


                <img src="images/casamento3.jpeg" alt="" ></img>

                
                

                <img src="images/casamento4.jpeg" alt="" ></img>
    
            
                <img src="images/casamento5.jpeg" alt="" ></img>


                <img src="images/casamento6.jpeg" alt="" ></img>




                <img src="images/casamento7.jpeg" alt="" ></img>

                
'               <img src="images/casamento8.jpeg" alt="" ></img>


                <img src="images/casamento9.jpeg" alt="" ></img>




                <img src="images/casamento10.jpeg" alt="" ></img>

                <img src="images/casamento11.jpeg" alt="" ></img>
        '                
                <img src="images/casamento12.jpeg" alt="" ></img>



                <img src="images/casamento13.jpeg" alt="" ></img>

                <img src="images/casamento14.jpeg" alt="" ></img>

                <img src="images/casamento15.jpeg" alt="" ></img>



                <img src="images/casamento16.jpeg" alt="" ></img>

                <img src="images/casamento17.jpeg" alt="" ></img>

                <img src="images/casamento18.jpeg" alt="" ></img>



                <img src="images/casamento19.jpeg" alt="" ></img>

                <img src="images/casamento20.jpeg" alt="" ></img>
                
                <img src="images/casamento21.jpeg" alt="" ></img>
        


                <img src="images/navio.jpeg" alt="" ></img>
        
            
                <img src="images/navio2.jpeg" alt=""></img>
            
    
           
        </div>


)

    
   




}
export default Fotos;